import { FbBox, FbIconButton, FbTypeography } from "@flexibees/core";
import OpenInNewOutlinedIcon from "@material-ui/icons/OpenInNewOutlined";
import FilterListOutlinedIcon from "@material-ui/icons/FilterListOutlined";
import EditOutlinedIcon from "@material-ui/icons/EditOutlined";
import JobStatusFliter from "../components/utilities/JobStatusFliter";
import { COLORS } from "../constants/colors";


const formatDate = (date) => {
  if (!date) return "-";

  return new Date(date)
    .toLocaleDateString("en-GB") // 30/08/2025
    .replace(/\//g, "-");        // 30-08-2025
};

export const columnTitle = (classes, label) => () => (
  <FbBox className={classes.tags} style={{ width: 120 }}>
    <FbTypeography
      variant="body1"
      className={[classes.textTransform_none, classes.rowTitle]}
    >
      {label}
    </FbTypeography>
  </FbBox>
);

export const textCell = (classes, value, options = {}) => (
  <FbBox
    className={classes.tags}
    style={{ maxWidth: 160, cursor: options.cursor }}
    onClick={options.onClick}
  >
    <FbTypeography
      noWrap
      variant="body1"
      className={classes.textTransform_none}
    >
      {value ?? "-"}
    </FbTypeography>
  </FbBox>
);


export const getJobColumns = ({
  classes,
  jobStatus,
  filters,
  selectedJobStatus,
  handleJobStatusFilter,
  handleShowEditActivity,
  handleShowDescription,
  handleShowNotes,
  viewJobDetails,
  setIcon,
  icon,
  visibleColumns = [],
}) => {
  const allColumns = {
    id: {
      key: "id",
      dataIndex: "id",
      width: 250,
      fixed: "left",
      title: columnTitle(classes, "Job Id"),
      render: (id) => textCell(classes, id),
    },

    company_name: {
      key: "company_name",
      dataIndex: "company_name",
      width: 250,
      fixed: "left",
      title: columnTitle(classes, "Company Name"),
      render: (company_name, row) => (
        <FbBox
          style={{ display: "flex", alignItems: "center", maxWidth: 170 }}
          onMouseEnter={() => setIcon(row.id)}
          onMouseLeave={() => setIcon(null)}
        >
          {textCell(classes, company_name, {
            cursor: "pointer",
            onClick: () => viewJobDetails(row.id),
          })}
          {icon === row.id && (
            <FbIconButton
              onClick={() => viewJobDetails(row.id, true)}
              style={{ padding: 0, marginLeft: 4 }}
            >
              <OpenInNewOutlinedIcon style={{ fontSize: 14 }} />
            </FbIconButton>
          )}
        </FbBox>
      ),
    },

    role_name: {
      key: "role_name",
      dataIndex: "role_name",
      width: 200,
      title: columnTitle(classes, "Role name"),
      render: (v) => textCell(classes, v),
    },

    job_type: {
      key: "job_type",
      dataIndex: "job_type",
      width: 200,
      title: columnTitle(classes, "Hours"),
      render: (_, row) => textCell(classes, row?.details.job_type),
    },

    experience: {
      key: "experience",
      dataIndex: "experience",
      width: 200,
      title: columnTitle(classes, "Experience"),
      render: (_, row) => textCell(classes, row?.details.experience),
    },

    description: {
      key: "description",
      width: 200,
      title: columnTitle(classes, "Job Description"),
      render: (_, row) =>
        textCell(classes, row.description, {
          cursor: "pointer",
          onClick: () => handleShowDescription(row),
        }),
    },

     created_at: {
      key: "created_at",
      dataIndex: "created_at",
      width: 200,
      title: columnTitle(classes, "Created Date"),
      render: (_, row) => textCell(classes, formatDate(row?.created_at)),
    },

    notes: {
      key: "notes",
      width: 200,
      title: columnTitle(classes, "Notes"),
      render: (_, row) =>
        textCell(classes, row.notes, {
          cursor: row.notes ? "pointer" : "",
          onClick: () => handleShowNotes(row),
        }),
    },

    status: {
      key: "status",
      dataIndex: "status",
      width: 200,
      title: columnTitle(classes, "Status"),
      filterDropdown: () => (
        <JobStatusFliter
          data={filters.transformedJobStatusData}
          onChange={handleJobStatusFilter}
          checked={selectedJobStatus}
        />
      ),
      filterIcon: () => (
        <FilterListOutlinedIcon
          style={{
            color: selectedJobStatus.length ? COLORS.PRIMARY : undefined,
          }}
        />
      ),
      render: (status) => textCell(classes, jobStatus?.[status]),
    },

      pricing: {
      key: "pricing",
      dataIndex: "pricing",
      width: 200,
      title: columnTitle(classes, "Client Price"),
      render: (_, row) => textCell(classes, row?.pricing),
    },

     candidate_price: {
      key: "candidate_price",
      dataIndex: "candidate_price",
      width: 200,
      title: columnTitle(classes, "Candidate Price"),
      render: (_, row) => textCell(classes, row?.candidate_price),
    },

    edit: {
      key: "edit",
      width: 120,
      title: columnTitle(classes, "Edit"),
      render: (_, row) => (
        <FbIconButton onClick={() => handleShowEditActivity(row)}>
          <EditOutlinedIcon />
        </FbIconButton>
      ),
    },
  };

  // ✅ return only required columns
  return visibleColumns.map((key) => allColumns[key]).filter(Boolean);
};